import { Component, OnInit } from '@angular/core';
import { PI } from '../constants-types/PI.model';

type DropdownItem = {
    onClick: Function;
    text: string;
};

@Component({
    selector: 'pi-pendo-dropdown',
    template: `
        @if (isEnabled) {
            <pi-dropdown
                [list]="dropdownList"
                [placeholder]="
                    'Pendo ' + (pendoOn ? '(Enabled)' : '(Disabled)')
                "
                (onSelected)="dropdownClick($event)"
                [direction]="{ horizontal: 'left', vertical: 'bottom' }"
            >
                <ng-template let-item="item">{{ item.text }}</ng-template>
            </pi-dropdown>
        }
    `,
    standalone: false
})
export class PendoDropdownComponent implements OnInit {
    dropdownList: DropdownItem[] = [];

    isEnabled: boolean;
    pendoOn = PI.appSettings.pendoOn;

    constructor() {
        this.isEnabled = PI.appSettings.enablePendoDropdown;
    }

    ngOnInit() {
        this.dropdownList = [];
        if (this.pendoOn) {
            this.dropdownList.push({
                text: 'Disable Pendo',
                onClick: () => {
                    document.cookie =
                        'PI_OVERRIDE_PENDO_ENABLE=; expires=31 Dec 1700 12:00:00 UTC; path=/';
                    window.location.reload();
                }
            });
        } else {
            this.dropdownList.push({
                text: 'Enable Pendo',
                onClick: () => {
                    document.cookie =
                        'PI_OVERRIDE_PENDO_ENABLE=; expires=31 Dec 2100 12:00:00 UTC; path=/';
                    window.location.reload();
                }
            });
        }
    }

    dropdownClick(item: DropdownItem): void {
        item.onClick();
    }
}
